export type LanguageCode = 'en' | 'nl' | 'es';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'es',
		file: 'es.ts',
	},
];

export default languages;
